import { render, staticRenderFns } from "./Tanto.vue?vue&type=template&id=5711a5b8&scoped=true&lang=pug&"
import script from "./Tanto.vue?vue&type=script&lang=coffee&"
export * from "./Tanto.vue?vue&type=script&lang=coffee&"
import style0 from "./Tanto.vue?vue&type=style&index=0&id=5711a5b8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5711a5b8",
  null
  
)

export default component.exports